var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1441 8.51289V5.51289H13.1441V4.81289H16.1441V1.81289H16.8441V4.81289H19.8441V5.51289H16.8441V8.51289H16.1441ZM6.81914 6.36289C6.07664 6.36289 5.44106 6.09856 4.91239 5.56989C4.38356 5.04106 4.11914 4.40539 4.11914 3.66289C4.11914 2.92039 4.38356 2.28472 4.91239 1.75589C5.44106 1.22722 6.07664 0.962891 6.81914 0.962891C7.56164 0.962891 8.19722 1.22722 8.72589 1.75589C9.25472 2.28472 9.51914 2.92039 9.51914 3.66289C9.51914 4.40539 9.25472 5.04106 8.72589 5.56989C8.19722 6.09856 7.56164 6.36289 6.81914 6.36289ZM0.119141 13.3629V12.0629C0.119141 11.6962 0.231641 11.3504 0.456641 11.0254C0.681641 10.7004 0.985807 10.4462 1.36914 10.2629C2.28581 9.82956 3.19831 9.50456 4.10664 9.28789C5.01497 9.07122 5.91914 8.96289 6.81914 8.96289C7.71914 8.96289 8.62331 9.07122 9.53164 9.28789C10.44 9.50456 11.3525 9.82956 12.2691 10.2629C12.6525 10.4462 12.9566 10.7004 13.1816 11.0254C13.4066 11.3504 13.5191 11.6962 13.5191 12.0629V13.3629H0.119141Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonAdd);
export default __webpack_public_path__ + "static/media/person_add.d11cff53471609b6a4d3e741d003ce5e.svg";
export { ForwardRef as ReactComponent };